import { create } from 'zustand';

const useConfirmationModalStore = create((set, get) => ({
    isOpen: false,
    content: null,
    action: null,
    confirmText: null,

    open: (content, action, options = {}) => set({
        isOpen: true,
        content,
        action,
        confirmText: options.confirmText || null
    }),

    close: () => set({
        isOpen: false,
        content: null,
        action: null,
        confirmText: null
    }),

    confirm: () => {
        const { action } = get();
        if (action) {
            action();
        }
        set({ isOpen: false, content: null, action: null, confirmText: null });
    },
}));

export default useConfirmationModalStore;
